import React from "react";
import { FormControl, InputLabel, Select, MenuItem } from "@material-ui/core";
import { formatTeamsData } from "./ChartBuilder/teamFilterComponents";

const TeamFilterHierarchySingleSelect = ({
  label,
  value,
  onChange,
  name,
  disabled,
  labelColorCondition,
  renderValue,
  getOptionLabel,
  getOptionValue,
  data,
  onTeamChange,
}) => {
  // Prepare formatted team list with hierarchy indentation
  const teamsList = formatTeamsData(data);

  // Handle single selection change
  const handleChange = (e) => {
    const selectedValue = e.target.value;
    console.log("Selected Team:", selectedValue);

    // Call both optional handlers for flexibility
    if (onChange) onChange(e);
    if (onTeamChange) onTeamChange(selectedValue);
  };

  return (
    <FormControl fullWidth disabled={disabled}>
      <InputLabel
        id={`${name}-label`}
        style={{
          color: labelColorCondition ? "#4472c4" : "#000",
        }}
      >
        {label}
      </InputLabel>
      <Select
        labelId={`${name}-label`}
        name={name}
        value={value || ""}
        onChange={handleChange}
        renderValue={renderValue}
        data-test="Team"
      >
        {teamsList.map((option) => (
          <MenuItem
            key={getOptionValue(option)}
            value={option.label}
            style={{
              marginLeft: `${option.indent * 1}rem`,
            }}
          >
            {getOptionLabel(option)}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default TeamFilterHierarchySingleSelect;
